import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '../../../components/Modal';
import Select from '../../../components/Select';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';
import Manipulator from '../../../utils/dom/manipulator';
import Request from '../../../utils/request';
import Pagination from '../../../components/Pagination';

class WorkCardsContent {
	constructor() {
		this.queryParameters = this.getQueryParameters(window.location.href);
		this.state = {
			selectedYear: this.queryParameters.year,
			selectedPage: this.queryParameters.p,
			workId: undefined
		};
		this._container = SelectorEngine.findOne('.lta-work-cards');

		if (this._container) {
			this.init();
		}
	}

	init() {
		const year = SelectorEngine.findOne('.lta-work-cards__content-year .js-lta-select', this._formWrapper);
		this.yearElement = Select.getInstance(year) || new Select(year);
		EventHandler.on(this.yearElement._selectNativeElement, 'change', this.saveYearValue.bind(this));

		this._deleteWorkCardModal = new Modal(SelectorEngine.findOne('#lta-work-cards__delete-modal'), {});

		this._deleteCancelCta = SelectorEngine.findOne('.lta-work-cards__delete-cancel-cta', this._container);
		EventHandler.on(this._deleteCancelCta, 'click', (event) => {
			event.preventDefault();
			this._deleteWorkCardModal.hide();
		});

		this._deleteCta = SelectorEngine.findOne('.lta-work-cards__delete-confirm-cta', this._container);
		this._deleteCta.addEventListener('click', (event) => {
			event.preventDefault();
			this.triggerDeleteWorkCardApi(event);
		});

		this._cardContainer = SelectorEngine.findOne('.lta-work-cards__card-container', this._container);
		this._allEditWorkCardsCta = SelectorEngine.find('.lta_work-cards__edit-cta', this._cardContainer);
		for (const link of this._allEditWorkCardsCta) {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				this.editWorkCard(event);
			});
		}

		this._allDeleteWorkCardsCta = SelectorEngine.find('.lta_work-cards__delete-cta', this._cardContainer);
		for (const link of this._allDeleteWorkCardsCta) {
			link.addEventListener('click', (event) => {
				event.preventDefault();
				this.deleteWorkCard(event);
			});
		}

		this.paginationElement = SelectorEngine.findOne('.lta-pagination', this._container);
		this.pagination = new Pagination(this.paginationElement);
		this.pagination.onChange((page) => {
			this.state.selectedPage = page.toString();
			this.changeHandler();
		});
	}

	getQueryParameters(url) {
		const queryParameters = {};
		const queryString = url.split('?')[1];

		if (queryString) {
			const parameters = queryString.split('&');

			for (const parameter_ of parameters) {
				const parameter = parameter_.split('=');
				const parameterName = decodeURIComponent(parameter[0]);
				const parameterValue = decodeURIComponent(parameter[1]);
				queryParameters[parameterName] = parameterValue;
			}
		}

		return queryParameters;
	}

	changeHandler() {
		if (this.state.selectedPage && this.state.selectedYear) {
			window.location.href =
				window.location.pathname + '?p=' + this.state.selectedPage + '&year=' + this.state.selectedYear;
		} else if (this.state.selectedPage && !this.state.selectedYear) {
			window.location.href = window.location.pathname + '?p=' + this.state.selectedPage;
		} else if (!this.state.selectedPage && this.state.selectedYear) {
			window.location.href = window.location.pathname + '?year=' + this.state.selectedYear;
		}
	}

	saveYearValue() {
		const yearValue = this.yearElement._selectNativeElement.value;
		this.state.selectedYear = yearValue;
		this.changeHandler();
	}

	async triggerDeleteWorkCardApi(event) {
		event.preventDefault();
		startLoadingAnimation(true);
		try {
			const url = `/api/officials/deleteworkcard?workId=${this.state.workId}`;
			const responseData = await Request.delete(url);

			const { success } = responseData;
			if (success) {
				const redirectUrl = Manipulator.getDataAttribute(this._container, 'redirect-url');
				window.location.href = redirectUrl;
			} else {
				// this._errorContainer.classList.remove('u-hidden');
				// this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			}
		} catch {
			// this._errorContainer.classList.remove('u-hidden');
			// this._errorText.innerHTML = Manipulator.getDataAttribute(this._container, 'api-failed-error');
			// this._errorContainer.scrollIntoView();
		} finally {
			stopLoadingAnimation();
		}
	}

	deleteWorkCard(event) {
		const tournamentName = Manipulator.getDataAttribute(event.target, 'tournament-name');
		const tournamentCode = Manipulator.getDataAttribute(event.target, 'tournament-code');
		const tournamentStartDate = Manipulator.getDataAttribute(event.target, 'tournament-start-date');
		const tournamentEndDate = Manipulator.getDataAttribute(event.target, 'tournament-end-date');
		const tournamentDaysWorked = Manipulator.getDataAttribute(event.target, 'tournament-days-worked');
		this.state.workId = Manipulator.getDataAttribute(event.target, 'work-id');
		const tournamentDetails = {
			tournamentCode: tournamentCode,
			tournamentName: tournamentName,
			tournamentStartDate: tournamentStartDate,
			tournamentEndDate: tournamentEndDate,
			tournamentDaysWorked: tournamentDaysWorked
		};
		this._deleteWorkCardModal.show();
		const outputElement = SelectorEngine.findOne('#tournament-details-container', this._container);
		outputElement.innerHTML = '';
		for (const key in tournamentDetails) {
			if (tournamentDetails.hasOwnProperty(key)) {
				const p = document.createElement('p');
				const span = document.createElement('span');

				// Set the value of the <span> element
				span.textContent = tournamentDetails[key];

				// Append the <span> to the <p> element
				p.append(span);

				// Append the <p> element to the output container
				outputElement.append(p);
			}
		}
	}

	editWorkCard(event) {
		const url = Manipulator.getDataAttribute(event.target, 'href');
		window.location.href = url;
	}
}

const globalWorkCardsContent = new WorkCardsContent();

export default globalWorkCardsContent;
